import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  it: {
    translation: {
      "Home": "Home",
      "Chi Siamo": "Chi Siamo",
      "FAQ": "FAQ",
      "Contatti": "Contatti",
      "Servizi": "Servizi",
      "Simulatore": "Simulatore",
      "Castello SRL": "Castello SRL",
      "Castello SRL - Soluzioni Immobiliari": "Castello SRL - Soluzioni di Gestione Immobiliare",
      "Gestione professionale di affitti brevi con approccio data-driven per massimizzare il ROI del tuo investimento immobiliare": "Gestione professionale di affitti brevi con approccio data-driven per massimizzare il ROI del tuo investimento immobiliare",
      "Accedi al simulatore gratuito": "Calcola il tuo Guadagno",
      "Scopri quanto puoi guadagnare dal tuo immobile": "Stima il potenziale del tuo immobile in pochi click",
      "Consulenza Gratuita": "Consulenza Gratuita",
      "Servizi Integrati": "Servizi Integrati",
      "Soluzione completa per la gestione professionale di affitti brevi": "Soluzione completa per la gestione professionale di affitti brevi",
      "Garanzie Professionali": "Garanzie Castello SRL",
      "Testimonianze Clienti": "Cosa dicono di noi",
      "Inizia la Trasformazione del Tuo Investimento": "Ottimizza il tuo Investimento oggi",
      "Unisciti a oltre 150 proprietari che hanno ottimizzato i loro investimenti immobiliari con la nostra gestione professionale.": "Unisciti ai proprietari che hanno scelto la nostra gestione professionale per massimizzare i profitti.",
      "Società di Gestione": "Società di Gestione Immobiliare",
      "Management": "Il Team Castello SRL",
      "Tutta Italia": "Operativi in tutta Italia",
      "Manda il messaggio": "Invia Richiesta",
      "Contattaci via Email": "Scrivici una Email",
      "Chiamaci Ora": "Chiamaci Ora",
      "Consulenza gratuita di 60 minuti": "Consulenza gratuita specializzata",
      "Setup completo in 7 giorni": "Attivazione rapida in 7 giorni",
      "Garanzia risultati 90 giorni": "Garanzia di rendimento",
      "Marketing Digitale": "Marketing & Visibilità",
      "Guest Management": "Gestione Ospiti & H24",
      "Facility Management": "Pulizie & Manutenzione",
      "Revenue Optimization": "Ottimizzazione Ricavi",
      "La nostra missione è offrire una gestione completa \"chiavi in mano\" per proprietari di immobili in affitto breve": "Offriamo una gestione completa \"chiavi in mano\" per trasformare il tuo immobile in una rendita passiva sicura.",
      "La Nostra Missione": "La Missione di Castello SRL",
      "I Nostri Valori": "I Nostri Valori Cardine"
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "it",
    fallbackLng: "it",
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;